import { type ReactNode } from 'react'
import { Icon, type IconName } from '@/icons/Icon'

/**
 * 注意バナー。design/js/components.jsx:139-144 を移植。
 *
 *   tone: 'info' (既定) | 'warn' | 'danger'  ← theme.css 側のクラスに対応
 *   ico:  IconName。省略時は 'info'。
 */
export type NoticeTone = 'info' | 'warn' | 'danger'

export interface NoticeProps {
  tone?: NoticeTone
  ico?: IconName
  children: ReactNode
}

export const Notice = ({ tone, ico, children }: NoticeProps): JSX.Element => (
  <div className={`notice${tone ? ` ${tone}` : ''}`} role="status">
    <span className="ico">
      <Icon name={ico ?? 'info'} />
    </span>
    <div>{children}</div>
  </div>
)
